export default class ScrollAware extends HTMLElement {


}

customElements.define("scroll-aware", ScrollAware);